<template>
    <div>
        <b-modal size="xl" id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-create-question-bank"
            @hidden="resetModal">
            <div class="container modal-create-question-bank__body">
                <div class="action"><img class="btn-close custom-cursor btn-float-right" src="@/assets/img/x.png"
                        @click="handleHideModal" /></div>
                <div class="header-modal margin-top-10">
                    <h3>Thư viện</h3>
                </div>
                <div class="row margin-top-10">
                    <div class="col-md-4">
                        <div class="item item__key input-custom-icon">
                            <input v-model.lazy="paramQueryData.keyword" v-debounce="1000" type="text"
                                placeholder="Tìm kiếm theo bài giảng tham khảo"
                                class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width" />
                            <i class="icon-search font-size-16 primary-color"></i>
                        </div>
                        <div class="row margin-top-10">
                            <div class="col-md-6">
                                <b-form-select @change="handleChangeClassId" v-model="paramQueryData.classId"
                                    :options="listDataClass">
                                    <!-- <option value=0>Tất cả</option> -->
                                </b-form-select>
                            </div>
                            <div class="col-md-6">
                                <b-form-select @change="handleChangeSubjectId" v-model="paramQueryData.subjectId"
                                    :options="listDataSubject">
                                    <!-- <option value=0>Tất cả</option> -->
                                </b-form-select>
                            </div>
                        </div>
                        <div class="custom-line">
                            <div class="line1"></div>
                            <div class="text-line">Nguồn bài giảng tham khảo</div>
                            <div class="line1"></div>
                        </div>
                        <div class="filter-source-question">
                            <div>Sách</div>
                            <div class="filter-book">
                                <b-form-checkbox-group v-model="paramQueryData.listBookTypeId" :options="listBookType"
                                    name="flavour-2a" stacked></b-form-checkbox-group>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="count-result">Tổng: {{ totalRecords }} kết quả</div>
                        <div class="wrap-right" ref="scrollContainer" @scroll="handleScroll">
                            <div class="" v-if="listDataBookLesson.length > 0">
                                <div class="question-item display-flex" v-for="(item, index) of listDataBookLesson"
                                    :key="index">
                                    <div class="question col-md-8">
                                        {{ item.title }}
                                    </div>
                                    <div class="col-md-4">
                                        <div class="row p-10">
                                            <a href="javascript:;" @click="handleView(item)"
                                                class="item btn border-rd-20 font-size-16 display-flex-center item__add col-md-6">
                                                Xem trước
                                            </a>
                                            <a href="javascript:;" :disabled="isDisabledButton"
                                                @click="handleClickBookLesson(item)"
                                                class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add col-md-6">
                                                Sử dụng
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center" v-else>
                                Bài giảng tham khảo không có dữ liệu
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form_action display-flex justity-content-end">
                    <button type="button"
                        class="btn btn-cancel border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                        :disabled="isLoading" @click="handleHideModal">
                        Hủy bỏ
                    </button>
                </div>
            </div>
        </b-modal>
        <ModalViewDocument :item="dataItemView" v-if="isOpenModalViewDocument" @closeModal="closeModalViewDocument" />
    </div>
</template>

<script>
import debounce from "@/directives/debounce";
import { getAllTypeFilter, getAllClassFilter } from "./../../../_api/";
import { saveDocument } from './../../../_api/documentClassSchoolServices'
import { getListBookLessonPlan } from './../../../_api/documentClassSchoolServices'
import {
    REFERENCE_LECTURE
} from './../../../constants/constants_enum'
import ModalViewDocument from './../../../_components/ModalViewDocument'
export default {
    name: "ModalLectureLibrary",
    directives: { debounce },
    components: {
        ModalViewDocument
    },
    props: {
        form: {
            type: Object,
            default: {}
        }
    },
    watch: {
        // 'paramQueryData.classId': 'handleChangeClassId',
        // 'paramQueryData.subjectId': 'handleChangeSubjectId',
        "paramQueryData.keyword": "handleSearchData",
        "paramQueryData.listBookTypeId": "handleChangeBookTypeId",
    },

    data() {
        return {
            REFERENCE_LECTURE,
            isOpenModalViewDocument: false,
            isDisabledButton: false,
            confirmActive: {},
            submitted: false,
            isLoading: false,
            statusSearch: 0,
            listDataSubject: [{ value: 0, text: "Tất cả - môn" }],
            listDataClass: [{ value: 0, text: "Tất cả - lớp" }],
            listDataBookLesson: [],
            totalRecords: 0,
            totalPage: 0,
            paramQueryData: {
                keyword: "",
                pageIndex: 1,
                pageSize: 20,
                subjectId: 0,
                classId: 0,
                listBookTypeId: []
            },
            listBookType: [
                { text: "Kết nối tri thức với cuộc sống", value: 3 },
                { text: "Chân trời sáng tạo", value: 4 },
                { text: "Cùng học để phát triển năng lực", value: 5 },
                { text: "Vì sự bình đẳng và dân chủ trong giáo dục", value: 6 },
            ],
            listQuestionAdd: [],
            dataDocument: null,
            dataItemView: {}
        };
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
    },
    mounted() {
        this.dataDocument = this.form
        this.GetAllClass();
        this.handleShowModal();
        this.getListData()
    },

    methods: {
        closeModalViewDocument() {
            this.isOpenModalViewDocument = false
        },
        handleView(item) {
            this.dataItemView = {
                typeDocument: REFERENCE_LECTURE,
                bookLessonPlanId: item.bookLessonPlanId
            }
            this.isOpenModalViewDocument = true
        },
        handleClickBookLesson(item) {
            let self = this
            this.dataDocument.bookLessonPlanId = item.bookLessonPlanId
            this.isDisabledButton = true
            saveDocument(this.dataDocument).then(res => {
                if (res && res.data && !res.errors) {
                    if (this.dataDocument.id > 0) {
                        self.$toast.success('Cập nhật bài giảng thành công')
                    } else {
                        self.$toast.success('Thêm mới bài giảng thành công')
                    }
                    this.handleDone()
                }
                self.isDisabledButton = false
            })
        },
        handleScroll() {
            const container = this.$refs.scrollContainer;
            const scrollHeight = container.scrollHeight;
            const scrollTop = container.scrollTop;
            const offsetHeight = container.offsetHeight;
            const bottomOffset = scrollHeight - (scrollTop + offsetHeight);
            if (bottomOffset <= 0 && !this.isLoading) {
                // Load more items when the user reaches the bottom with some offset
                let pageIndexSearch = this.paramQueryData.pageIndex + 1;
                if (pageIndexSearch <= this.totalPage) {
                    console.log("getdataa");
                    this.paramQueryData.pageIndex++;
                    this.getListData();
                }
            }
        },
        getListData() {
            let self = this;
            getListBookLessonPlan(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    if (res && res.data && !res.errors) {
                        for (let i = 0; i < res.data.list.length; i++) {
                            const item = res.data.list[i];
                            self.listDataBookLesson.push({ ...item });
                        }

                        self.totalRecords = res.data.paging.totalRecords;
                        self.totalPage = res.data.paging.totalPage;
                    }
                }
            })
        },
        handleChangeSubjectId(e) {
            //this.subjectId = e.target.value
            this.handleOnFilter();
        },
        handleChangeClassId(e) {
            this.getTypesFilter();
            //this.classId = e.target.value
            this.handleOnFilter();
        },
        handleSearchData() {
            this.handleOnFilter();
        },
        handleChangeBookTypeId() {
            this.handleOnFilter();
        },
        resetData() {
            this.paramQueryData.pageIndex = 1;
            (this.listDataBookLesson = []), (this.totalRecords = 0), (this.totalPage = 0);
        },
        handleOnFilter() {
            this.statusSearch = 1
            this.resetData();
            this.getListData()
        },
        getTypesFilter() {
            let self = this;
            self.listDataSubject = [{ value: 0, text: "Tất cả - môn" }];
            this.subjectId = 0;
            getAllTypeFilter({ classId: this.paramQueryData.classId }).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({
                            value: item.subjectId,
                            text: item.name,
                        });
                    }
                }
            });
        },
        GetAllClass() {
            let self = this;
            getAllClassFilter({}).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name });
                    }
                }
            });
        },
        handleDone() {
            this.handleHideModal();
            this.$emit("handleDone");
        },
        resetModal() {
            console.log("resetModal");
            this.submitted = false;
        },
        toggleModal() {
            this.$refs["modal-create-question-bank"].toggle("#toggle-btn");
        },
        handleHideModal() {
            //this.$refs['modal-create-question-bank'].hide()
            this.$emit("closeModal");
        },
        handleShowModal() {
            this.$refs["modal-create-question-bank"].show();
        },
    },
};
</script>
<style>
.question .input-hide-place {
    width: 40px;
}
</style>
<style lang="scss" scoped>
.loadding {
    color: green;
}

.modal-create-question-bank__body {
    padding: 20px;
    background-color: white;
    border-radius: 15px;

    // custom size modal
    max-width: 90%;
    top: 2%;
    left: 5%;
    right: 0;
    position: fixed;
    z-index: 100000;
    margin: 0px;

    .modal__actions {
        margin-top: 10px;

        .btn-delete {
            color: white;
            background: #fe0201;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
            font-family: sans-serif;
        }

        .btn-cancel {
            margin-right: 10px;
            color: #dd352f;
            font-family: sans-serif;
        }
    }
}

.justity-content-end {
    justify-content: end
}

.wrap-right {
    padding: 5px;
    border-radius: 10px;
    border: 1px solid #eaeaea;
    max-height: calc(80vh - 20px);
    overflow: auto;
}

.question-item {
    padding: 10px;
    overflow: auto;
    margin: 5px;
    border: 1px solid #a1b5f3;
    border-radius: 15px;
}

.margin-top-10 {
    margin-top: 10px;
}

.justify-content-space-between {
    justify-content: space-between;
}

.custom-line {
    width: 100%;
    display: flex;
    margin-top: 20px;
    padding-left: 20px;
    padding-right: 20px;

    .line1 {
        width: 30%;
        height: 2px;
        background: #e5e5e5;
    }

    .line2 {
        width: 30%;
        height: 2px;
        background: #e5e5e5;
    }

    .text-line {
        margin-top: -10px;
        padding-left: 10px;
        padding-right: 10px;
        color: #e5e5e5;
        width: 200px;
        font-size: 14px;
    }
}

.btn-float-right {
    float: right;
    width: 15px;
}
</style>
